import { render } from "./CustomMenu.vue?vue&type=template&id=35ddf633"
import script from "./CustomMenu.vue?vue&type=script&lang=js"
export * from "./CustomMenu.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__